import axios from 'axios';

import { apiConfig } from '../config';

export const api = axios.create({
  baseURL: apiConfig.apiUrl,
  timeout: 30000,
  headers: {
    'Content-type': 'application/json',
  },
});
